// Presentation only, never an authentication, entitlement or billing boundary.
export const isEmbeddedOdysseyApp = (host = window) => Boolean(
  typeof host.ReactNativeWebView?.postMessage === 'function'
  || /^OdysseyAI-Mobile\//.test(host.navigator?.userAgent || ''),
);

// Optional client telemetry remains off in the native companion until it has
// a separate, revocable opt-in. Also fail closed for mobile preview/routes,
// before the native bridge becomes available. This is not an auth boundary.
export const optionalTelemetryAllowed = (host = typeof window === 'undefined' ? null : window) => {
  if (!host || isEmbeddedOdysseyApp(host)) return false;
  return new URLSearchParams(host.location?.search || '').get('mode') !== 'mobile';
};

export const companionPlanningNotice = (notice) => {
  if (!notice) return notice;
  const purchaseLink = [notice.primaryCta?.to, notice.secondaryCta?.to]
    .some(to => typeof to === 'string' && /^\/upgrade(?:[/?#]|$)/i.test(to));
  if (notice.type !== 'upgrade' && !purchaseLink) return notice;
  return {
    type: 'info',
    title: 'Planning paused',
    description: 'No planning requests are available right now. You can still review your saved trips and check their sources. Daily free requests renew automatically.',
  };
};
